import React, { useState, useRef, useMemo, useEffect } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'

import { useConvertSurvey } from '../hooks/useConvertSurvey'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import 'survey-core/i18n/traditional-chinese'
import { useSurveyParams } from '../context/SurveyParamsContext'
import { useProgressSaving } from '../hooks/useProgressSaving'
import {
  convertVisibleIf,
  convertQuestionMappings,
} from '../utils/convertVisibleIf'

const Agree = ({
  setAc,
  setTk,
  ac,
  tk,
  pid,
  setIsLoading,
  setCompletionMessage,
}) => {
  const { userId, sfdSamplerId, sfdPId } = useSurveyParams()
  const [myAgreeJson, setMyAgreeJson] = useState(null)
  // 需要登入嗎
  const requiresLogin = {
    login: userId ? true : false,
    title: '員工編號（邁達特：MA、啟迪：GI、聚上雲：EP、逐鹿：GU）',
    placeholder: 'MA00000',
    alert: '員工編號有誤，請重新登入，謝謝',
  }
  const [imagesReadingTime, setImagesReadingTime] = useState(0)
  const canShowPrevButtonPages = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
  ]
  const choicesOrderRef = useRef({})
  const choiceIndexMapRef = useRef({})
  const bringOptionsMapRef = useRef({})
  const userIdRef = useRef(null)
  useEffect(() => {
    if (userId) userIdRef.current = userId
  }, [userId])
  // 防止閃閃
  useEffect(() => {
    const timeout = setTimeout(() => {
      const isMobile = window.innerWidth <= 576
      if (!isMobile) return

      const observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList') {
            const rootEl = document.querySelector('.sd-root-modern')
            if (
              rootEl &&
              !rootEl.classList.contains('sd-root-modern--mobile')
            ) {
              rootEl.classList.add('sd-root-modern--mobile')
              console.log('✅ 強制加上 mobile class 避免抖動')
            }
          }
        }
      })

      observer.observe(document.getElementById('root'), {
        childList: true,
        subtree: true,
      })

      // 清除
      return () => observer.disconnect()
    }, 100) // 100ms 後再判斷

    return () => clearTimeout(timeout)
  }, [])
  // 圖片閱讀時間(秒)
  // useEffect(() => {
  //   setImagesReadingTime(30)
  // }, [])
  const completedHtml = `<h3>問卷正在提交中，請稍候。</h3><h3>請在成功頁面顯示後再離開。</h3><h4>如有填卷相關問題請洽：</h4> <a href='https://lin.ee/HWETcqy'>https://lin.ee/HWETcqy</a><h4 style='margin-top:50px'>填寫其他問卷：</h4> <a href=${window.location.origin}>${window.location.origin}</a>`

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const agreeSurvey = new Model(myAgreeJson)

  // 問卷編號
  // const pid = pid
  // 跳題 小心複選題要用陣列

  // q69~q148 沿用 P251110160042921（苗栗苑裡兒童問卷）69~141 的跳題邏輯設定，
  // 對照確認：兩份問卷此區間題號 1:1 對應（如 I4a/I4b、L.社會參與矩陣、S5-1a~f 皆同題號同結構）。
  // 該份問卷未使用 convertVisibleIf，程式碼內是系統原生（0-based）表達式，這裡轉換回 1-based 再套用本檔案慣例的 convertVisibleIf。
  // 不疊加 q68 gate 條件：q69~q148 只沿用移植過來的原始條件，不依 Q68 的作答判斷。
  const visibleIfConditionsInitBase = {
    q74: '{q73} = 1',
    q75: '{q73} = 2 or {q73} = 3',
    q76: '{q73} = 2 or {q73} = 3 or {q73} = 4 or {q73} = 5 or {q73} = 6',

    q82: '{q14} = 101', // 隱藏（沿用來源問卷「不可能成立」的永久隱藏寫法）

    q84: '{q83} = "other"',
    q85: '{q83} = "other"',
    q87: '{q86} = "other"',
    q88: '{q86} = "other"',

    q91: '{q90} = 2 or {q90} = 3',
    q92: '{q90} = 2 or {q90} = 3',
    q93: '{q90} = 2 or {q90} = 3',
    q94: '{q90} = 2 or {q90} = 3',
    q95: '{q90} = 2 or {q90} = 3',
    q96: '({q90} = 2 or {q90} = 3) and ({q95} = 1)',
    q97: '({q90} = 2 or {q90} = 3) and ({q95} = 2)',
    q98: '{q90} = 2 or {q90} = 3',
    q99: '{q90} = 2 or {q90} = 3',
    q100: '{q90} = 2 or {q90} = 3',
    q101: '{q90} = 2 or {q90} = 3',
    q102: '{q90} = 2 or {q90} = 3',

    q104: '{q103} = 1 or {q103} = 2',

    // 特殊矩陣（L.社會參與）
    q108: '{q107.1} = 1',
    q109: '{q107.2} = 1',
    q110: '{q107.3} = 1',
    q111: '{q107.4} = 1',
    q112: '{q107.1} = 2 or {q107.2} = 2 or {q107.3} = 2 or {q107.4} = 2',
    'q112.row1': '{q107.1} = 2',
    'q112.row2': '{q107.2} = 2',
    'q112.row3': '{q107.3} = 2',
    'q112.row4': '{q107.4} = 2',

    q128: '{q127} anyof [1, 2, 3, "other"]',
    q129: '{q127} anyof [1, 2, 3, "other"]',
    q130: '{q127} anyof [1, 2, 3, "other"]',
    q131: '{q127} anyof [1, 2, 3, "other"]',

    q132: '({q127} anyof [1, 2, 3, "other"])',
    q133: '({q127} anyof [1, 2, 3, "other"]) and ({q131.1} = 1 or {q131.1} = 2)',
    q134: '({q127} anyof [1, 2, 3, "other"]) and ({q131.2} = 1 or {q131.2} = 2)',
    q135: '({q127} anyof [1, 2, 3, "other"]) and ({q131.3} = 1 or {q131.3} = 2)',
    q136: '({q127} anyof [1, 2, 3, "other"]) and ({q131.4} = 1 or {q131.4} = 2)',
    q137: '({q127} anyof [1, 2, 3, "other"]) and ({q131.5} = 1 or {q131.5} = 2)',
    q138: '({q132} = "other")',

    q140: '{q139} = 2',
    q141: '{q139} = 2',
  }

  // 沒有移植條件的題號（如 Q69~72、77~80、89、105~106、113~126、142~148）
  // 維持無 visibleIf（一律顯示），不額外補條件
  const visibleIfConditionsInit = convertVisibleIf(visibleIfConditionsInitBase)

  // q1~q68 是兒童的資料，之前已在苗栗苑裡兒童問卷問過，本問卷一律隱藏。
  const forceHiddenQuestions = convertVisibleIf(
    Object.fromEntries(
      Array.from({ length: 68 }, (_, i) => [`q${i + 1}`, 'false'])
    )
  )

  // 非必填(從 0 計算)
  // const notRequired = [117.5]
  const notRequired = null

  const mappedRateChoice = null
  // const pageBreakQuestions = ['q6', 'q11', 'q15']
  const pageBreakQuestions = null

  const triggersConditionsInit = null
  const questionMappings = convertQuestionMappings({})

  const convertedSurvey = useConvertSurvey({
    survey: agreeSurvey,
    pid,
    setAc,
    setTk,
    ac,
    tk,
    setMyAgreeJson,
    imagesReadingTime,
    setImagesReadingTime,
    setIsLoading,
    completedHtml,
    visibleIfConditionsInit,
    notRequired,
    mappedRateChoice,
    pageBreakQuestions,
    requiresLogin,
    triggersConditionsInit,
    questionMappings,
    bringOptionsMapRef,
    userIdRef,
    choiceIndexMapRef,
    sfdSamplerId,
    sfdPId,
    forceHiddenQuestions,
  })

  // const newSurvey = new Model(convertedSurvey)

  const surveyModel = useMemo(() => {
    if (!convertedSurvey) return null
    return new Model(convertedSurvey)
  }, [convertedSurvey])

  useProgressSaving({
    userIdRef,
    surveyModel,
    convertedSurvey: myAgreeJson,
    requiresLogin,
    setIsLoading,
    pid,
    ac,
    tk,
    choiceIndexMapRef,
    choicesOrderRef,
    bringOptionsMapRef,
    sfdSamplerId,
  })

  // 當 surveyModel 建立時，自動捲動到頂端
  useEffect(() => {
    if (surveyModel) {
      // 延遲執行以確保 DOM 已更新
      setTimeout(() => {
        // 捲動到頁面頂端
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'instant', // 平滑捲動，也可以使用 'instant' 立即跳到頂端
        })

        // 或者也可以嘗試捲動問卷容器本身
        const surveyContainer = document.querySelector('.sd-root-modern')
        if (surveyContainer) {
          surveyContainer.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }, 100) // 給 DOM 一點時間完成渲染
    }
  }, [surveyModel])

  // useEffect(() => {
  //   console.log('convertedSurvey', convertedSurvey)
  // }, [convertedSurvey])

  function helpFunction(survey, options) {
    // console.log('survey.getValue(q42)', survey.getValue('q42'))
    // 參考 P231113152849 或 P231101165555 或 P231206105643(政大帶入選項)
  }

  const endSurveyMsg = (survey) => {
    setCompletionMessage(
      `<div>感謝您的填答～歡迎轉發分享！<br><br>想參加更多問卷調查活動？手指點點就可以抽獎賺好康！<br>點擊下方按鈕加入 EZChoice APP<br>或複製下載連結 <a href="https://ezcapp.page.link/tAQv" target="_blank">https://ezcapp.page.link/tAQv</a><br>裡面還有更多填問卷拿購物金的活動唷～<br>各種好玩的問卷等你來玩！<br><br>想知道更多好康問卷、活動消息，請追蹤關注<br><a href="https://www.facebook.com/EasyCTRs" target="_blank">【輕鬆點點】粉絲專頁</a><br><br>加入我們的 <a href="https://lin.ee/HWETcqy" target="_blank">LINE@</a>，<br>隨時得到最新填問卷獲好禮的消息。<br><br><h4 style="text-align: center">請按「完成」前往下載 EZChoice 或填寫更多問卷</h4></div>`
    )
  }

  // useEffect(() => {
  //   console.log('bringOptionsMapRef', bringOptionsMapRef)
  // }, [bringOptionsMapRef])

  useSubmitAnswers({
    survey: surveyModel,
    pid,
    ac,
    tk,
    imagesReadingTime,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    choicesOrderRef,
    choiceIndexMapRef,
    endSurveyMsg,
    bringOptionsMapRef,
    requiresLogin,
    userIdRef,
    enableProgressSaving: requiresLogin.login || !!sfdSamplerId,
    sfdSamplerId,
  })

  return (
    <>
      {surveyModel ? (
        <Survey model={surveyModel} key={pid} />
      ) : myAgreeJson ? (
        <Survey model={agreeSurvey} />
      ) : (
        <></>
      )}
    </>
  )
}

export default Agree
